var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"suggestions-entry"},[_c('span',{staticClass:"query-text"},[_vm._v(_vm._s(_vm.suggestionDisplayValues.startPart))]),_vm._v(_vm._s(_vm.suggestionDisplayValues.rest)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }